import { render, staticRenderFns } from "./index.vue?vue&type=template&id=545e64a2&scoped=true&class=full-height&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=545e64a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e64a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545e64a2')) {
      api.createRecord('545e64a2', component.options)
    } else {
      api.reload('545e64a2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=545e64a2&scoped=true&class=full-height&", function () {
      api.rerender('545e64a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/viewPoint/index.vue"
export default component.exports